<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <v-data-table
        fixed-header
        :headers="$t('panel.adminManagement.adminsPage.table.headers')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        hide-default-footer
        @page-count="pageCount = $event"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        :class="shortList"
      >
        <template v-slot:item.fullName="{ item }">
          <span class="me-1">{{ item.firstName }}</span>
          <span>{{ item.lastName }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <router-link
            :to="{ name: 'editUserRoles', params: { userId: item.id } }"
            >{{
              $t("panel.adminManagement.adminsPage.table.content.detail")
            }}</router-link
          >
        </template>
      </v-data-table>

      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        ></v-pagination>
      </div>
    </div>
  </v-container>
</template>

<script>
import { userInfoService } from "@/services";
import setFiltersQueries from "@/mixins/setFilters&Queries";

export default {
  name: "admins",
  mixins: [setFiltersQueries],
  data() {
    return {
      pageCount: 0,
      totalPages: 1,
      loading: false,
      shortList: false,
      filtersObj: {
        page: 1,
        size: 10
      },
      tableData: []
    };
  },
  async mounted() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
  },
  methods: {
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    // setFiltersFromQuery() {
    //   Object.entries(this.$route.query).reduce((acc, [key, val]) => {
    //     if (key === "page" || key === "size") {
    //       this.filtersObj[key] = +val;
    //     } else this.filtersObj[key] = val;
    //   }, {});
    // },
    // updateQuery() {
    //   let queryParams = Object.entries(this.filtersObj).reduce(
    //     (acc, [key, val]) => {
    //       if (!val) return acc;
    //       return { ...acc, [key]: val };
    //     },
    //     {}
    //   );
    //   this.$router.replace({ query: { ...queryParams } }, () => {});
    //   this.getAllAdmins(queryParams);
    // },
    loadData(filters) {
      this.loading = true;
      userInfoService
        .getAllAdmins(filters)
        .then(response => {
          this.tableData = response.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
